import { render, staticRenderFns } from "./CROMSQualityCrosswalkReview.vue?vue&type=template&id=181028cf&"
import script from "./CROMSQualityCrosswalkReview.vue?vue&type=script&lang=js&"
export * from "./CROMSQualityCrosswalkReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports